<template>
  <button
    :class="{'is-playing': isPlaying, dark: isDark, [size]: size, disabled: !epi || !epi.id}"
    :disabled="!epi || !epi.id"
    :aria-label="isPlaying ? 'Pause' : 'Play'"
    class="play-pause"
    @click.prevent="togglePlay"
  >
    <slot
      v-if="isPlaying"
      name="pause"
    >
      <IconPause />
    </slot>
    <slot
      v-else
      name="play"
    >
      <IconPlay />
    </slot>
  </button>
</template>

<script>
import IconPause from '../assets/svg/pause.svg'
import IconPlay from '../assets/svg/play.svg'
import Store from '../store'

export default {
  components: {
    IconPause,
    IconPlay
  },
  data () {
    return {
      store: Store
    }
  },
  computed: {
    audio () { return this.store.state.audio },
    color () { return this.store.state.color },
    epi () { return this.store.state.episode },
    isDark () { return this.store.state.isDark },
    isLoaded () { return this.store.state.isLoaded },
    isPlaying () { return this.store.state.isPlaying },
    isWaiting () { return this.store.state.isWaiting },
    size () { return this.store.state.size }
  },
  methods: {
    togglePlay () {
      if (this.audio.src === '') {
        this.store.setAudioSrc(this.epi.enclosure_url)
        this.store.setIsPlaying(false)
      }

      if (this.isPlaying) {
        this.store.setIsWaiting(false)
        this.audio.pause()
      } else {
        if (!this.isLoaded) this.store.setIsWaiting(true)

        this.audio.play()
      }
      this.store.setIsPlaying(!this.isPlaying)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';
@import '../assets/styles/breakpoints.scss';

button.play-pause {
  background: transparent;
  border: 2px solid $black-trans-800;
  color: $black-trans-800;
  border-radius: 100%;
  cursor: pointer;
  justify-content: center;
  margin: 0;
  padding: 0;
  position: relative;

  @media (min-width: $bp_xs) {
    align-self: center;
  }

  &.disabled {
    cursor: default;
    svg {
      fill: $grey-300;
    }
  }

  &.dark {
    border: 2px solid $white-trans-800;
    color: $white-trans-800;

    svg {
      fill: $white-trans-800;
      color: $white-trans-800;
    }
    &.disabled {
      svg {
        fill: $grey-700;
        color: $grey-700;
      }
    }
  }
  // MINI PLAYER STYLES
  &.size-mini {
    height: 36px;
    display: flex;
    margin-right: 8px;
    width: 36px;
  }
  svg {
    fill: $black-trans-800;
    height: calc(100% + 2px);
    width: calc(100% + 2px);
    position: absolute;
    top: -1px;
    left: -1px;
  }
}
</style>
